import React, { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import styles from "./components.module.scss";
import { AppData } from "../../../context/context";
import AutoSelect from "./AutoSelect";

const GenderLanguage = ({
  uniqueKey = "",
  data = null,
  eligibilityData = null,
  setEligibilityData,
  setShowLanguageList,
}) => {
  const { formMode, jobConfigMode } = useContext(AppData);

  /* Other states */

  const [mode, setMode] = useState("");

  /* UseEffects */

  useEffect(() => {
    if (uniqueKey === "jobConfig") {
      setMode(jobConfigMode);
    } else {
      setMode(formMode);
    }
  }, [uniqueKey, jobConfigMode]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: "30px",
      }}
    >
      <Typography
        className={`${styles.formFont} flexDisplayColumn`}
        style={{ rowGap: "17px", alignItems: "flex-start" }}
      >
        <span className="fontWeight500">{data.title}</span>
        <span className={`${styles.greydedText}`} style={{ fontSize: "14px" }}>
          {data.placeHolder}
        </span>
      </Typography>
      {uniqueKey === "jobConfig" && mode === "view" ? (
        <div
          className={
            data.valueKey === "gender" ||
            (data.valueKey === "language" &&
              eligibilityData[data.valueKey]?.length === 0)
              ? `${styles.textBoxView} ${styles.textBoxViewDisable}`
              : `${styles.chipContainer}`
          }
          style={{
            padding:
              data.valueKey === "language" &&
              eligibilityData[data.valueKey]?.length > 0
                ? "16px 0px"
                : !eligibilityData[data.valueKey] ||
                  !eligibilityData[data.valueKey]?.length
                ? "24px"
                : "",
          }}
        >
          {data.valueKey === "gender"
            ? eligibilityData[data.valueKey]?.name
            : eligibilityData[data.valueKey]?.slice(0, 4).map((obj, index) => (
                <span key={index} className={styles.chip}>
                  {obj?.name}
                </span>
              ))}
          {eligibilityData[data.valueKey]?.length > 4 && (
            <button
              className={`${styles.showMoreBtn}`}
              style={{ background: "none", fontSize: "14px" }}
              onClick={(e) => setShowLanguageList(true)}
            >
              View more
            </button>
          )}
        </div>
      ) : uniqueKey === "eligibilityCriteria" && data.type === "dropdown" ? (
        <AutoSelect
          data={eligibilityData}
          setData={setEligibilityData}
          id={data.valueKey}
          multipleFlag={data.multipleFlag}
          placeHolder={data.placeHolder1}
          list={data.list}
        />
      ) : (
        ""
      )}
    </Box>
  );
};

export default GenderLanguage;
